import React from "react";
import { Grid, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import * as Constants from "../../../../consts/Constants.js";
import Style from "../../../../styles/js/StyleCallList.js";
import Pagination from "@material-ui/lab/Pagination";
import { useHistory } from 'react-router-dom';
import Button from "@material-ui/core/Button";

import { formatDateDDMMYYYYHHMM } from "../../../../plas/utils";
import { callStates, applicationStates } from "../../../../plas/services/calls/models.jsx";
import service from '../../../../plas/services/calls/service';
import alerter from "../../../alerts/alerter"

export default function MyApplications() {

  let history = useHistory();
  const style = Style();

  const [applications, setApplications] = React.useState([]);

  // Constantes para la paginación
  const itemsPerPage = 12;
  const [page, setPage] = React.useState(1);
  const [noOfPages, setNoOfPages] = React.useState(0);

  React.useEffect(() => {
    getApplications(page);
  }, [page]);

  const getApplications = () => {
    let startItem = (page - 1) * itemsPerPage;
    let endItem = page * itemsPerPage - 1;

    service.api.applications.getPage(startItem, endItem, (response) => {
      if (response.result != null) {
        setApplications(response.result.data);
        setNoOfPages(Math.ceil(response.result.total / itemsPerPage));
      } else {
        alerter.showError(response.error);
      }
    });
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const selectApplication = (application) => {
    history.push("/calls/my-applications/" + application.id)
  }

  return (

    <div className={style.box} >
      <div className={style.box} >
        <div className={[style.row, style.rowHeader].join(' ')}>
          <Typography variant="h4" style={{ marginBottom: "20px" }}>
            Mis postulaciones
          </Typography>
        </div>

        <div className={[style.row, style.rowContent].join(' ')}>
          <Grid container spacing={3} style={{ width: "100%", justifyContent:"center" }}>
            {applications !== undefined && applications.map((application) => (
                <Grid item key={application.id} style={{ display: "flex", justifyContent: "flex-start" }}>
                <Card>
                  <div className={style.item}>
                    <div className={style.itemHeader} style={ application.call.state !== 2 || application.call.hasResults() ? callStates.getByCode(application.call.state).style : null}>
                      <Typography className={style.titleInitial}>
                        {application.call.name}
                      </Typography>
                    </div>
                    <div style={{ paddingLeft: "12px", paddingRight: "12px", textAlign: "left"}}>
                      <div className={style.itemContent}>
                        <Typography className={style.bodyInitial}>
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Código de postulación: </span>
                          <span>#{application.callId}-{application.id}</span>
                        </Typography>
                        <Typography className={style.bodyInitial} >
                          <span style={{ color: Constants.COLOR_GRAY_DARK }}>Estado: </span>
                          <span>{ applicationStates[application.state] + " (" + formatDateDDMMYYYYHHMM(application.lastUpdate) + ")"}</span>
                        </Typography>

                        { application.call.state !== 2 ? (
                          <Typography className={style.bodyInitial} >
                            <span style={{ fontWeight: "bold", color: Constants.COLOR_GRAY_DARK }}>Convocatoria {callStates.getByCode(application.call.state).name.toLowerCase()}</span>
                          </Typography>
                          ) : (
                          <div>
                            { application.call.result != null ?
                              (
                                <Typography className={style.bodyInitial} >
                                  <span style={{ fontWeight: "bold", color: Constants.COLOR_GRAY_DARK }}>Últimos resultados: </span>
                                  <span>{formatDateDDMMYYYYHHMM(application.call.result.time)}</span>
                                </Typography>
                              ) : (
                                <Typography className={style.bodyInitial}>
                                  <span style={{ color: Constants.COLOR_GRAY_DARK }}>Fecha de cierre: </span>
                                  <span>
                                  { application.extensionDate !== undefined ?
                                    formatDateDDMMYYYYHHMM(application.extensionDate) + " (prórroga)" :
                                    formatDateDDMMYYYYHHMM(application.call.endDate)
                                  }
                                  </span>
                                </Typography>
                              )
                            }
                          </div>
                          )
                        }
                    
                      </div>
                    </div>

                    <div className={style.itemFooter}>
                      <div >
                        <Button
                          onClick={ () => { selectApplication(application) }}
                          className={style.actionButton}
                          style={{...application.call.state !== 2 || application.call.hasResults() ? callStates.getByCode(application.call.state).style : {background: Constants.COLOR_PRIMARY, color: 'white'}, minWidth:'100px' }}
                          variant="contained">
                          <b>{ application.canSend() ? "Editar" : "Ver" }</b>
                        </Button>
                      </div>
                    </div>
                  </div>
                  </Card>
                </Grid>
              ))}
          </Grid>
        </div>

        <div className={[style.row, style.rowHeader].join(' ')}>
          <Pagination 
            style={{ justifyContent:"center", display:'flex',  marginTop: '15px', marginBottom: '15px'}}
            count={noOfPages}
            showFirstButton
            showLastButton
            onChange={handleChange}/>
        </div>
      </div>
    </div>
  );

}
